__turbopack_context__.v({
  "button": "common-button-module-scss-module__N6Ai9W__button",
  "button_gray": "common-button-module-scss-module__N6Ai9W__button_gray",
  "button_outline": "common-button-module-scss-module__N6Ai9W__button_outline",
  "button_outline_disabled": "common-button-module-scss-module__N6Ai9W__button_outline_disabled",
  "button_primary": "common-button-module-scss-module__N6Ai9W__button_primary",
  "button_primary-outline": "common-button-module-scss-module__N6Ai9W__button_primary-outline",
});
